import { render } from "./BorderHeroBottom.vue?vue&type=template&id=f3ac52c4&scoped=true"
import script from "./BorderHeroBottom.vue?vue&type=script&lang=js"
export * from "./BorderHeroBottom.vue?vue&type=script&lang=js"

import "./BorderHeroBottom.vue?vue&type=style&index=0&id=f3ac52c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3ac52c4"]])

export default __exports__